/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* userpreference-service.ts  2025-08-12T13:43:44+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { PreferenceTagOption, UserPreference, PreferenceUpdateDTO } from './wy-dto';

const _ = 'UserPreference/';

export class UserPreferenceService {

  constructor(readonly r: RpcService) {}
  // 获取所有偏好标签选项
  getAllPreferenceOptions(m?: M): R<Array<PreferenceTagOption>>{
    return this.r.async(_ + 'getAllPreferenceOptions', undefined, m);
  }
  // 获取用户已选偏好
  getUserPreference(m?: M): R<UserPreference>{
    return this.r.async(_ + 'getUserPreference', undefined, m);
  }
  // 新增或更新用户的偏好设置
  updateUserPreference(d:PreferenceUpdateDTO, m?: M): R<number>{
    return this.r.async(_ + 'updateUserPreference', d, m);
  }
}
